import {
  posthogEvents,
  userDetailsFormSources
} from '@/shared/constants/constants';

// Shared across every UserDetailsModal/ProfileDetailsFields consumer.
// Not every source has every field (e.g. UserDetailsModal has no last_name,
// ProfileDetailsFields has no email) -- callers only ever fire the ones
// their own form actually shows.
export type UserDetailsFormField =
  'first_name' | 'last_name' | 'email' | 'craft' | 'skill';

export type UserDetailsFormSource =
  (typeof userDetailsFormSources)[keyof typeof userDetailsFormSources];

export const trackUserDetailsFormShown = (
  formSource: UserDetailsFormSource,
  properties?: Record<string, unknown>
): void => {
  window.posthog?.capture(posthogEvents.USER_DETAILS_FORM_SHOWN, {
    form_source: formSource,
    ...properties
  });
};

export const trackUserDetailsFormSubmitted = (
  formSource: UserDetailsFormSource,
  properties?: Record<string, unknown>
): void => {
  window.posthog?.capture(posthogEvents.USER_DETAILS_FORM_SUBMITTED, {
    form_source: formSource,
    ...properties
  });
};

export const trackUserDetailsFormFieldFilled = (
  field: UserDetailsFormField,
  formSource: UserDetailsFormSource,
  properties?: Record<string, unknown>
): void => {
  window.posthog?.capture(posthogEvents.USER_DETAILS_FORM_FIELD_FILLED, {
    field,
    form_source: formSource,
    ...properties
  });
};
